import React from 'react';
import ReactDOM from 'react-dom';
import Toast from './toast';

// 抱歉实现得有点儿low，暂时没什么好方案

const isBrowser = typeof window !== 'undefined';

let toastWrapper: HTMLElement;
if (isBrowser) {
  toastWrapper = document.createElement('div');
  toastWrapper.className = 'toast-component';
  document.body.appendChild(toastWrapper);
}

const toastController = {
  show: (text: string, time = 1500, textStyle?: any) => {
    textStyle = textStyle || {};
    toastWrapper && ReactDOM.render(<Toast text={text} textStyle={textStyle}/>, toastWrapper);
    toastWrapper.style.display = 'block';
    setTimeout(() => (toastWrapper.style.display = 'none'), time);
  },
};

export default toastController;
